import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@features/auth/hooks/useAuthStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div
        role="status"
        aria-live="polite"
        aria-label="Loading"
        className="flex h-screen items-center justify-center"
      >
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
